export interface CompanyDto {
	id: number;
	name: string;
	address: string;
	email: string;
	contactName: string;
	active: boolean;
	defaultTimeZoneId: number;
	geocodingMethod: number;
	geocodingFormat: number;
}

export interface CompanyResponseDto {
	id: number;
	name: string;
}

export enum ClientUsersByCompanyFilterType {
	ALL_CLIENT_USERS = 'ALL_CLIENT_USERS',
	CLIENT_ADMIN_USERS = 'CLIENT_ADMIN_USERS',
	CLIENT_USERS_BY_ROLE = 'CLIENT_USERS_BY_ROLE',
}

export type ClientsUsersByCompanyParams = {
	id: number;
	clientId: number;
	search?: string;
	filterType: ClientUsersByCompanyFilterType;
};
